export const CATEGORY = '/category/' as const
export const CATEGORY_ALL = `${CATEGORY}all` as const
